//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/PointList.js";
import "../no/ugmath.js";
import "../no/ObjectList.js";
let d=[[[1,"PointList",0,"PointList",0]],[[[],"FindPaths",{},0,0],[[],"CyclePaths",{},0,0],[["nFilterPaths"],"GetFilterPaths",{R_:{filterPaths:"Routing.Path[]"}},0,0],[["filterPaths"],"SetFilterPaths",{},1,0],[["nPaths"],"GetPaths",{R_:{paths:"Routing.Path[]"}},0,0],[["point"],"UpdateFilterPaths",{R_:{foundPath:''}},1,0],[["points","nPaths","foundPath"],"FindPathsFromMultiplePoints",{R_:{paths:"Routing.Path[]"}},1,0],[[],"GetHighlightPath",{R_:{path:"Routing.Path"}},0,0],[["path"],"SetHighlightPath",{},1,0],[["pointLocs","nValidPoints","validPoints","nFilterPaths"],"CreateValidPointsOnPaths",{R_:{filterPaths:"Routing.Path[]"}},1,0]],[]];
SPLM.Routing.ManualRouteBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.ManualRouteBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;